import React, { Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import AppCheckBox from '@/ui/checkbox';
import Outline from './outline';
import TextList from './text-list';
import planQuestionStore from './store';
import AddCart from './add-cart';
import PPTChoice from './ppt-choice';
import { runInAction } from 'mobx';

const TitleAndTips = ({ title, tips, titleClass = '', tipsClass = '' }) => {
  return (
    <>
      {title ? (
        <div
          className={[
            'text-14px text-black font-bold leading-20px mb-8px',
            titleClass,
          ]}
        >
          {title}
        </div>
      ) : null}

      {tips ? (
        <div
          className={[
            'mb-8px leading-20px text-14px text-black text-opacity-70',
            tipsClass,
          ]}
        >
          {tips}
        </div>
      ) : null}
    </>
  );
};

const ContentList = observer(props => {
  const { className = '', disable, requested, planStepId, list = [], event } = props;

  if (!list?.length) return null;

  return (
    <div className={['pt-8px', className]}>
      {list.map((item, index) => {
        switch (item.type) {
          case 'text':
            return (
              <div
                key={index}
                className="mb-12px leading-20px text-14px text-black text-opacity-70"
              >
                {item.tips}
              </div>
            );
          case 'outline':
            return (
              <Fragment key={index}>
                <TitleAndTips
                  titleClass="!mb-14px !text-16px"
                  title={item.title}
                  tips={item.tips}
                />
                <div className="mb-20px last:mb-12px border-1px border-opacity-10 rounded-8px">
                  <div className="flex items-center h-40px bg-[#F7F7F7] text-black text-opacity-70 font-bold rounded-t-8px">
                    <div className="w-48px vh-center">序号</div>
                    <div className="w-0 flex-grow text-center">内容</div>
                  </div>
                  {item.items?.map((_item, _index) => {
                    return (
                      <Fragment key={_index}>
                        <Outline
                          parentIndex={index}
                          index={_index}
                          disable={disable || requested || !item.editable}
                          planStepId={planStepId}
                          itemType={item.type}
                          item={_item}
                          items={item.items}
                          event={event}
                        />
                      </Fragment>
                    );
                  })}
                </div>
              </Fragment>
            );
          case 'textlist':
            return (
              <Fragment key={index}>
                <TitleAndTips
                  titleClass="!mb-14px !text-16px"
                  title={item.title}
                  tips={item.tips}
                />
                <div className="js-table-wrap mb-20px last:mb-12px border-1px border-opacity-10 rounded-8px">
                  <div className="flex items-center h-40px bg-[#F7F7F7] text-black text-opacity-70 font-bold rounded-t-8px">
                    <div className="w-48px vh-center">序号</div>
                    <div className="w-130px vh-center p-10px">使用技能</div>
                    <div className="w-0 flex-grow pl-12px">内容</div>
                  </div>
                  {item.items?.map((_item, _index) => {
                    return (
                      <Fragment key={_index}>
                        <TextList
                          parentIndex={index}
                          index={_index}
                          disable={disable || requested || !item.editable}
                          planStepId={planStepId}
                          itemType={item.type}
                          item={_item}
                          items={item.items}
                          event={event}
                        />
                        {(_item.items || []).map((subItem, subIndex) => {
                          return (
                            <TextList
                              key={subIndex}
                              subIndex={subIndex + 1}
                              parentIndex={index}
                              index={_index}
                              disable={true}
                              planStepId={planStepId}
                              itemType={item.type}
                              item={subItem}
                              items={item.items}
                              event={event}
                            />
                          );
                        })}
                      </Fragment>
                    );
                  })}
                </div>
              </Fragment>
            );
          case 'goods_info':
            return (
              <AddCart
                key={index}
                parentIndex={index}
                list={item.items}
                disable={disable || requested}
                planStepId={planStepId}
                itemType={item.type}
              />
            );
           case 'radiobutton_ppt':
            return (
              <PPTChoice
                key={index}
                parentIndex={index}
                disable={disable || requested}
                planStepId={planStepId}
                itemType={item.type}
                item={item}
                items={item.items}
                event={event}
              />
            );
          case 'checkbox':
          case 'radiobutton':
            const otherItem = item.items?.find(
              item => item.action == 'add_text'
            );
            return (
              <div key={index} className="pb-16px">
                <TitleAndTips title={item.title} tips={item.tips} />
                <div className={['grid', `grid-cols-${item.column || 2}`]}>
                  {item.items?.map((_item, _index) => {
                    const isRadio = item.type == 'radiobutton';
                    return (
                      <div
                        key={_index}
                        onClick={evt => {
                          if (disable) return;
                          const resItem = item.items.map(
                            item => {
                              runInAction(()=>{
                                if (item.id == _item.id) {
                                  item.check = !item.check;
                                } else {
                                  if (isRadio) {
                                    item.check = false;
                                  }
                                }
                              });
                              return item;
                            }
                          );
                          planQuestionStore.updatePlanData(
                            planStepId,
                            item.type,
                            index,
                            'items',
                            resItem
                          );
                        }}
                        className={[
                          'flex items-center min-h-32px mb-4px pl-8px',
                          disable ? '' : 'cursor-pointer',
                        ]}
                      >
                        <AppCheckBox
                          isRadio={isRadio}
                          className={[
                            'size-16px mr-12px flex-shrink',
                            disable ? 'opacity-30' : '',
                          ]}
                          checked={_item.check}
                        />
                        <div className="text-14px break-all line-clamp-2 flex-grow w-0">
                          {_item.text}
                          {_item.tip ? (
                            <span className="text-black text-opacity-50 leading-16px">
                              {_item.tip}
                            </span>
                          ) : null}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {otherItem && otherItem.check ? (
                  <input
                    disabled={disable}
                    type="text"
                    placeholder={
                      disable ? '' : otherItem.action_tips || '请输入'
                    }
                    value={otherItem.input_text}
                    maxLength={otherItem.max_length}
                    onChange={evt => {
                      const resItem = item.items.map(
                        item => {
                          runInAction(()=>{
                            if (item.action == 'add_text') {
                              item.input_text = evt.target.value;
                            }
                          });
                          return item;
                        }
                      );
                      planQuestionStore.updatePlanData(
                        planStepId,
                        item.type,
                        index,
                        'items',
                        resItem
                      );
                    }}
                    className="h-40px leading-40px w-full px-12px text-black border-1px border-black border-opacity-16 rounded-8px"
                  />
                ) : null}
              </div>
            );
          case 'text_field':
            return (
              <div
                key={index}
                className="mb-12px leading-20px text-14px text-black text-opacity-70"
              >
                <TitleAndTips title={item.title} tips={item.tops} />
                <input
                  disabled={disable}
                  type="text"
                  placeholder={disable ? '' : item.placeholder || '请输入'}
                  value={item.text}
                  maxLength={item.max_length}
                  onChange={evt => {
                    planQuestionStore.updatePlanData(
                      planStepId,
                      item.type,
                      index,
                      'text',
                      evt.target.value
                    );
                  }}
                  className="h-40px leading-40px w-full px-12px mt-8px text-black border-1px border-black border-opacity-16 rounded-8px"
                />
              </div>
            );
          default:
            return null;
        }
      })}
    </div>
  );
});
export default ContentList;
